import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { Credentials } from '@shared/models/interfaces/credentials.interface';
import { Register, Trial } from '@shared/models/interfaces/register.interface';
import { Response } from '@shared/models/interfaces/response.interface';
import { AuthenticationService } from '@shared/providers/authentication.service';
import { HttpService } from '@shared/providers/http.service';
import { SetFlagIsLogout } from '@shared/store/controller/controller.actions';

interface LoginRequest {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService extends HttpService {
  constructor(
    private httpClient: HttpClient,
    private store: Store,
    private router: Router,
  ) {
    super('', httpClient, store);
  }

  doLogin(credentials: Credentials) {
    return this.postAsync<Credentials, Response<LoginRequest>>(credentials, environment.endpoints.login);
  }

  requestPasswordChange(userEmail) {
    return this.postAsync({ userEmail }, `${environment.endpoints.resetPassword}/request`);
  }

  reauth() {
    return this.getAsync(environment.endpoints.reauthenticate);
  }

  requestNewUser(user: Register) {
    return this.postAsync<Register, Response<{}>>(user, environment.endpoints.newUser);
  }

  async logout() {
    this.store.dispatch(new SetFlagIsLogout(true));
    await this.router.navigateByUrl('/').then(async () => {
      // canLeave need a redirect try to dispose alert
      AuthenticationService.instance.setAuthentication();
      // matcher need a redirect after logout process
      await this.router.navigateByUrl('/', { replaceUrl: true });
      this.store.dispatch(new SetFlagIsLogout(false));
    });
  }

  async getTrial() {
    return this.getAsync<Trial>(`${environment.endpoints.newUser}/${environment.endpoints.trial}`);
  }
}
